<template>
  <div class="storeSettingPin">
    <form @submit.prevent="saveSetting">
      <b-modal
        id="showModal"
        v-model="showModal"
        no-close-on-backdrop
        no-close-on-esc
        centered
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">Setting PIN</span>
        </div>
        <div>
          <b-container fluid>
            <b-row class="mt-2 typeCheck">
              <b-col md="12" class="text-muted mb-3">If Void/Cancel orders requires verification, please open it.</b-col>
              <b-col md="3">
                <label>Verification</label>
              </b-col>
              <b-col class="mt-1 fl justify-content-start align-items-center">
                <b-form-checkbox
                  id="void_validate"
                  v-model="obj.voidValidate"
                />
                <label for="void_validate">Open</label>
              </b-col>
            </b-row>
            <b-row v-if="obj.voidValidate" class="mt-2">
              <b-col md="3">
                <label>PIN</label>
              </b-col>
              <b-col
                :class="{ 'form-error': errors.first('PIN') }"
              >
                <b-form-input
                  v-model="obj.pinCode"
                  v-validate="'required|length:4'"
                  type="text"
                  name="PIN"
                  placeholder="4-character PIN"
                />
                <small>{{ errors.first('PIN') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success" :disabled="isSaving">
            <font-awesome-icon icon="save" />
            Save Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

library.add(faBars, faSave, faTimes);

export default {
  props: {
    input: {
      type: null,
      default: null,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      obj: {
        outletCode: '',
        voidValidate: false,
        pinCode: '',
      },
      isSaving: false,
    }
  },

  methods: {
    saveSetting() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.isSaving = true;
          this.$store
            .dispatch('UpdateStorePin', {
              ...this.obj,
              pinCode: this.obj.voidValidate ? this.obj.pinCode : '',
              voidValidate: this.obj.voidValidate ? 1 : 0,
            })
            .then((response) => {
              let res = getResponseToMTH(
                response,
                this.$swal,
                constants.RECORD_IS_UPDATED
              )
              if (res) {
                this.$emit('discard-modal', true)
              }
            })
            .catch((error) => {
              console.log(error);
              this.$swal(
                constants.SOMETHING_WROING,
                error,
                constants.STATUS_ERROR
              )
            })
            .finally(() => {
              this.isSaving = false;
            })
        }
      })
    },

    discardModal() {
      this.$emit('discard-modal')
    },

    reset() {
      this.obj = {
        outletCode: this.input.outlet_code,
        voidValidate: !!this.input.void_validate,
        pinCode: this.input.pin_code,
      }
    },
  },
}
</script>
